import React from 'react';
import styled from '@emotion/styled';
import { Button, Dropdown } from 'semantic-ui-react';
import GroupView from './groupView';
import { clickableStyles, s } from 'src/components/helpers';
import { screenSizes } from 'src/assets/styles/Literals';

const LeadersGroupsPage = styled.section`
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 1rem 1.25rem 2rem;
  box-sizing: border-box;
  background: #fff;
  border-radius: 16px;
  border: 1px solid #e9ecef;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  text-align: center;

  @media only screen and (max-width: ${screenSizes.mobile}) {
    padding: 0.85rem 0.75rem 1.5rem;
    border-radius: 12px;
  }

  h2 {
    text-align: center;
    padding: 0.5rem 0 0.75rem;
    margin: 0;
    color: #1a1a1a;
  }

  .filter-link {
    text-align: center;
    margin: 0 0 1.25rem;
  }

  .group-picker {
    max-width: 420px;
    margin: 0 auto 1.25rem;
    text-align: left;

    small {
      display: block;
      margin-bottom: 0.35rem;
      color: #666;
    }
  }

  .back-btn {
    display: inline-flex;
    margin: 0 0 0.75rem;
  }
`;

const LeadersAdminAllGroups = (props) => {
  const { inputs } = props;
  const [groupNames, set_groupNames] = React.useState([]);
  const [groupSelected, set_groupSelected] = React.useState(null);

  React.useEffect(() => {
    const names = inputs.groups.map((group) => {
      return {
        key: group.id,
        value: group.id,
        text: `${group.activityName.replace(/_/g, ' ')} - ${group.groupName}`,
      };
    });
    set_groupNames(names);
    if (!groupSelected) set_groupSelected(names[0].key);
  }, [inputs.groups]);

  const selectHandle = (a, { value }) => set_groupSelected(value);

  const showGroupSelected = () => inputs.groups.filter((group) => group.id === groupSelected)[0];

  return (
    <LeadersGroupsPage>
      {!Boolean(localStorage.getItem('userToken')) && (
        <Button
          className="back-btn"
          onClick={() =>
            window.location.replace(
              `/grupos/lider?phone=${props.inputs.phone}&identification=${props.inputs.identification}`
            )
          }
        >
          Atrás
        </Button>
      )}
      <h2>
        Bienvenido a tu{s(inputs.groups?.length)} grupo{s(inputs.groups?.length)}
      </h2>
      <p
        className="filter-link"
        style={{ ...clickableStyles, textAlign: 'center', margin: '0 0 1.25rem' }}
        onClick={() =>
          window.location.replace(
            `/grupos/lider?phone=${props.inputs.phone}&identification=${props.inputs.identification}&filterKindOfGroup=filter`
          )
        }
      >
        ¿Filtrar por tipo de grupo?
      </p>
      {inputs.groups.length > 1 && (
        <div className="group-picker">
          <small>Para cambiar, selecciona un grupo de la lista</small>
          <Dropdown
            placeholder="Selecciona un grupo"
            onChange={selectHandle}
            fluid
            selection
            value={groupSelected}
            options={groupNames}
          />
        </div>
      )}
      {showGroupSelected() && <GroupView {...props} group={showGroupSelected()} />}
    </LeadersGroupsPage>
  );
};

export default LeadersAdminAllGroups;
